import { render, staticRenderFns } from "./DiscountCode.vue?vue&type=template&id=5fc77dc1"
import script from "./DiscountCode.vue?vue&type=script&lang=ts"
export * from "./DiscountCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports